import React, { useState, useEffect, useRef } from "react";
import LeftSideItemWrapper from "./LeftSideItemWrapper";
import LeftSideItemContent from "./LeftSideItemContent";

function LeftSideItem({
    item,
    displayText,
    isChild,
    isBalance,
    isNotify,
    isLogout,
    setActiveRouteName,
    activeRouteName,
    onForceClose,
    isExpand
}) {

    const hasChildren = !!(item.children && item.children.length);
    const [displayChildren, setDisplayChildren] = useState(false);
    const titleRef = useRef(null);
    const [supportModal, setSupportModal] = useState(false)

    const goTo = (e, link) => {
        if (!hasChildren || !isExpand) {
            setActiveRouteName(link)
            onForceClose(false)
            return
        }

        e.preventDefault()
        e.stopPropagation()
        setDisplayChildren(!displayChildren);
    };
    const closeDropdown = () => {
        setDisplayChildren(false);
    };

    return (
        <LeftSideItemWrapper closeDropdown={closeDropdown} item={item} >
            <LeftSideItemContent
                item={item}
                displayText={displayText}
                displayChildren={displayChildren}
                hasChildren={hasChildren}
                isChild={isChild}
                isBalance={isBalance}
                isNotify={isNotify}
                isLogout={isLogout}
                titleRef={titleRef}
                goTo={goTo}
                setActiveRouteName={setActiveRouteName}
                activeRouteName={activeRouteName}
                isExpand={isExpand}
            />

        </LeftSideItemWrapper>
    );
}


export default LeftSideItem;
